import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { PageContainer } from '@/shared/components/layout';
import { Skeleton } from '@/shared/components/ui';
import { EmptyState } from '@/shared/components/ui/EmptyState';
import { useAuth } from '@/shared/hooks/useAuth';
import { useT } from '@/shared/i18n/useT';

/**
 * `/cuenta` exige sesión: sin ella se va a `/cuenta/entrar` recordando de dónde venía (`state.from`).
 * Mientras se renueva la sesión recordada no se decide nada (evita un parpadeo hacia «Entrar»).
 */
export function RequireSession() {
  const { isAuthenticated, isRestoring } = useAuth();
  const location = useLocation();
  if (isRestoring) {
    return (
      <PageContainer width="narrow">
        <Skeleton className="h-40 w-full rounded-lg" />
      </PageContainer>
    );
  }
  if (!isAuthenticated) {
    const from = `${location.pathname}${location.search}`;
    return <Navigate to="/cuenta/entrar" replace state={{ from }} />;
  }
  return <Outlet />;
}

/** `/admin/*` solo para `rol=admin`; quien tiene sesión sin ese rol ve «Sin permiso». */
export function RequireAdmin() {
  const { t } = useT();
  const { user, isAuthenticated, isRestoring } = useAuth();
  const location = useLocation();
  if (isRestoring) {
    return (
      <PageContainer width="narrow">
        <Skeleton className="h-40 w-full rounded-lg" />
      </PageContainer>
    );
  }
  if (!isAuthenticated) {
    return <Navigate to="/cuenta/entrar" replace state={{ from: location.pathname }} />;
  }
  if (user?.rol !== 'admin') {
    return (
      <PageContainer width="narrow">
        <EmptyState
          icon="balanza"
          title={t('states.noPermissionTitle')}
          description={t('states.noPermissionText')}
        />
      </PageContainer>
    );
  }
  return <Outlet />;
}
